module.exports = __webpack_public_path__ + "android-icon-144x144.png?6f36cf2a92ed99116a4e2b4d7d243593";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-144x144.png
// module id = 121
// module chunks = 0